import { UPDATE_AUTH } from '../actions'

const initialState = {
  isAuthenticated: !!localStorage.getItem('pincode'),
  showAuthForm: false
}

interface IPayload {
  name: string
  value: string
}

export default function init (previousState = initialState, { type, payload }: { type: string; payload: IPayload }) {
  return type === UPDATE_AUTH ? { ...previousState, [payload.name]: payload.value } : previousState
}
